import { useState } from "react";
import { FieldModel } from "../documentEditor/types";
import { getTemplateInfoById } from "../../../services/templateV2Service";

interface UseFieldsProps {
    currentTemplateId: string;
    setLoading: (loading: boolean) => void;
}

interface UseFieldsReturn {
    fields: FieldModel[];
    setFields: React.Dispatch<React.SetStateAction<FieldModel[]>>;
}

export const useFields = ({ currentTemplateId, setLoading }: UseFieldsProps): UseFieldsReturn => {
    const [fields, setFields] = useState<FieldModel[]>([]);

    return {
        fields,
        setFields
    };
};


